@if (selectedTicket()) {
  <div class="edit-container">
    <app-new-adhoc [aiTask]="true"
      [site]="siteS()"
      [sites]="sites()"
      [ticket]="selectedTicket()"
      (saved)="onTicketSave($event)"></app-new-adhoc>
  </div>
} @else {
  @switch (step()) {
    @case (1) {
      <div>
        @if (sites().length > 1) {
          <div class="ion-margin-bottom">
            <app-select-site-button [expand]="'block'"
              [selectedSite]="siteS()"
              [items]="sites()"
              [hasNew]="true"
              (selected)="onSite($event)"></app-select-site-button>
          </div>
        }
        <div class="flex flex-center">
          <app-speech-to-text [title]="'tickets.ai.speak'"
            (text)="onMic($event)"></app-speech-to-text>
          <app-take-video [name]="'aiVideo'"
            color="light"
            fill="clear"
            [title]="'item.recordVideo'"
            [multiline]="true"
            [returnRef]="true"
            (reference)="onReference($event)"></app-take-video>
        </div>
        <ion-textarea class="description"
          [counter]="true"
          maxlength="500"
          [(ngModel)]="description"
          autocapitalize="on"
          rows="5"
          [placeholder]="'tickets.ai.description' | translate">
        </ion-textarea>
        <ion-item class="single"
          lines="none">
          <ion-toggle aria-label=""
            [(ngModel)]="onlyOne">
            {{ 'site.ai.onlyOne' | translate }}
          </ion-toggle>
        </ion-item>
      </div>
      <div class="ion-margin-top">
        @if ({
          areas: areas$ | async,
        }; as vm) {
          @if (loading()) {
            <ion-progress-bar color="light"
              [value]="progress()"></ion-progress-bar>
          }
          <ion-button [disabled]="description.length === 0 || siteS() == null || loading()"
            color="light"
            shape="round"
            (click)="doTasks(description, vm.areas)">
            @if (loading()) {
              <ion-spinner slot="start"
                color="primary"></ion-spinner>
            }
            {{ 'tickets.ai.doTasks' | translate }}
          </ion-button>
        }
      </div>
    } @case (2) {
      <div>
        @if (residents().length > 0) {
          <h3>
            {{ 'tickets.ai.residents' | translate }}
          </h3>
          <p>{{ 'tickets.ai.perTable' | translate }}</p>
          <ion-list>
            @for (item of residents(); track $index; let index = $index) {
              <ion-item-sliding>
                <ion-item lines="none">
                  <app-carousel-item drag-scroll-item
                    [item]="item"></app-carousel-item>
                </ion-item>
                <ion-item-options>
                  <ion-item-option color="danger"
                    (click)="deleteItem(index, true)">
                    <ion-icon name="trash-outline"></ion-icon>
                  </ion-item-option>
                </ion-item-options>
              </ion-item-sliding>
            }
          </ion-list>
        }
        <h3>
          {{ 'tickets.ai.newItems' | translate }}
        </h3>
        <div class="ion-margin-bottom">
          {{ 'tickets.ai.found' | translate: { num: found().length} }}
        </div>
        <ion-list>
          @for (item of found(); track $index; let index = $index) {
            <ion-item-sliding>
              <ion-item lines="none">
                <app-carousel-item drag-scroll-item
                  [item]="item"
                  (klick)="onItem($event)"></app-carousel-item>
              </ion-item>
              <ion-item-options>
                <ion-item-option color="danger"
                  (click)="deleteItem(index)">
                  <ion-icon name="trash-outline"></ion-icon>
                </ion-item-option>
              </ion-item-options>
            </ion-item-sliding>
          }
        </ion-list>
        <ion-button color="light"
          [disabled]="invalidTickets()"
          shape="round"
          (click)="createTasks()">
          {{ 'tickets.ai.createTickets' | translate }}
        </ion-button>
      </div>
    } @case (3) {
      <div class="flex-center ion-margin-bottom">
        <ion-icon name="list-outline"></ion-icon>
      </div>
      <div>
        <h2>
          {{ 'tickets.ai.done' | translate }}
        </h2>
        <p [innerHTML]="'tickets.ai.doneInfo' | translate"></p>
        <div class="list">
          <div>{{ 'tickets.ai.doneSum' | translate:{ num: summary().length } }}</div>
          <app-tickets-created [tickets]="summary()"></app-tickets-created>
        </div>
      </div>
      <div class="ion-margin-top flex">
        <ion-button color="light"
          shape="round"
          (click)="more()">
          {{ 'tickets.ai.more' | translate }}
        </ion-button>
        <ion-button color="secondary"
          shape="round"
          (click)="end()">
          {{ 'tickets.ai.end' | translate }}
        </ion-button>
      </div>
    }
  }
}